import React, { Component } from 'react';
import {Route} from 'react-router-dom'
import locale from './lang/locale.json';
import Login from'./routes/login/Login'
import PropTypes from "prop-types";

class PrivateRoute extends Component {
    static propTypes = {
        path : PropTypes.string,
        locale : PropTypes.string,
        isLoggedIn : PropTypes.bool
    };

    checkRedirect(match){
        const Component = this.props.component;
        if(this.props.isLoggedIn){
            return <Component id={match.params.id} locale={locale[this.props.locale]}/>
        }
        else {
            return <Login locale={locale.Login}/>
        }
    }

    render() {
        return (
            <Route exact path={this.props.path} render={({match}) => this.checkRedirect(match)}/>
        );
    }
}

export default(PrivateRoute)


// WEBPACK FOOTER //
// ./src/PrivateRoute.js